import averageIntensity from "./data/average-intensities.min.js";
import marginalIntensity from "./data/marginal-intensities-2021.min.js";
import electricityMaps from "./data/electricity-maps/index.js";

export { averageIntensity, marginalIntensity, electricityMaps };
export default { averageIntensity, marginalIntensity, electricityMaps };
